import React, { useEffect, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { PolicyGeneralWrapper, BottomCTAsWrapper, ProtocolsCTAs, PolicyGeneralContent, BackButton } from "./styles";
import parse from "html-react-parser";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";


const PolicyPage = ({ selectedLang, token }) => {

  const history = useHistory();
  const [content, setContent] = useState("");
  const [t] = useTranslation("global");

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_ANTIAGING_API}api/antiaging/pages`, {
        headers: {
          "Content-Language": selectedLang,
          Authorization: `Bearer ${token}`,
        },
        params: { identifier: "privacy-policy" },
      })
      .then(({ data }) => setContent(data.results))
      .catch(console.error);
  }, [token, selectedLang]);
  return (
    <PolicyGeneralWrapper>
      <BackButton onClick={() => history.goBack()}>{t("productsBodyshock.back")}</BackButton>

      <PolicyGeneralContent>

        {parse(content)}
      </PolicyGeneralContent>

      <BottomCTAsWrapper>
        <ProtocolsCTAs protocolId={true} onClick={() => history.push("/home")} >home</ProtocolsCTAs>
      </BottomCTAsWrapper>
    </PolicyGeneralWrapper>

  )

};


const mapStateToProps = (state) => ({
  token: state.user.data.api_token,
  selectedLang: state.languages.selectedLanguage,
});

export default connect(mapStateToProps, null)(PolicyPage);